export const types = {
    NEW_CHECKBOOK_REQUEST: "checks/NEW_CHECKBOOK_REQUEST",
    NEW_CHECKBOOK_REQUEST_DATA_SHOW: "checks/NEW_CHECKBOOK_REQUEST_DATA_SHOW",
    CHECKBOOK_CREDENTIAL_REQUEST: "checks/CHECKBOOK_CREDENTIAL_REQUEST",
    CHECKBOOK_CREDENTIAL_SUCCESS: "checks/CHECKBOOK_CREDENTIAL_SUCCESS",
    CHECKBOOK_TICKET_REQUEST: "accounts/CHECKBOOK_TICKET_REQUEST",
    CHECKBOOK_TICKET_SUCCESS: "accounts/CHECKBOOK_TICKET_SUCCESS",
    CLEAN_NEW_CHECKBOOK_TICKET: "accounts/CLEAN_NEW_CHECKBOOK_TICKET",
    EMIT_ECHEQ_BENEFICIARY: "checks/EMIT_ECHEQ_BENEFICIARY",
};

export const INITIAL_STATE = {
    newCheckbookRequest: {
        checksAccountSelector: "",
        checkbookAmount: "",
        checksPerCheckbook: "",
        firstName: "",
        lastName: "",
        retrieverId: {
            code: "",
            type: "",
        },
    },
    newCheckbookShouldShowLastValues: false,
    newCheckbookData: {
        account: "Cuenta corriente ***1333 CC $",
        checksPerCheckbookQuantity: "25",
        checkQuantity: "1",
        documentType: "DNI",
        documentNumber: "40905444",
        name: "Roberto",
        lastName: "Plant",
    },
    newCheckbookRequiredCredentials: [],
    newCheckbookTicket: { status: "", idTransaction: "" },
    newCheckbookTicketSignable: true,
    emitEcheqData: {},
};

export default (state = INITIAL_STATE, action = {}) => {
    const {
        newCheckbookRequest,
        newCheckbookShouldShowLastValues,
        newCheckbookRequiredCredentials,
        newCheckbookTicket,
    } = action;

    switch (action.type) {
        case types.NEW_CHECKBOOK_REQUEST:
            return {
                ...state,
                newCheckbookRequest,
            };
        case types.NEW_CHECKBOOK_REQUEST_DATA_SHOW:
            return {
                ...state,
                newCheckbookShouldShowLastValues,
            };
        case types.CHECKBOOK_CREDENTIAL_SUCCESS:
            return {
                ...state,
                fetching: false,
                newCheckbookRequiredCredentials,
            };
        case types.CHECKBOOK_TICKET_REQUEST:
            return {
                ...state,
                newCheckbookTicket: { status: "", idTransaction: "" },
            };
        case types.CHECKBOOK_TICKET_SUCCESS:
            return {
                ...state,
                newCheckbookTicket,
                newCheckbookTicketSignable: !(newCheckbookTicket.status !== "INVALID_CREDENTIAL"),
            };
        case types.CLEAN_NEW_CHECKBOOK_TICKET:
            return {
                ...state,
                newCheckbookTicket: { status: "", idTransaction: "" },
            };
        default:
            return state;
    }
};

export const actions = {
    setNewCheckbookRequest: (newCheckbookRequest) => ({
        type: types.NEW_CHECKBOOK_REQUEST,
        newCheckbookRequest,
    }),
    setNewCheckbookShouldShowLastValues: (newValue) => ({
        type: types.NEW_CHECKBOOK_REQUEST_DATA_SHOW,
        newCheckbookShouldShowLastValues: newValue,
    }),
    fetchCredentialGroup: () => ({
        type: types.CHECKBOOK_CREDENTIAL_REQUEST,
    }),
    setNewCheckbookCredential: (newCheckbookData) => ({
        type: types.CHECKBOOK_TICKET_REQUEST,
        newCheckbookData,
    }),
    cleanNewCheckbookTicket: () => ({
        type: types.CLEAN_NEW_CHECKBOOK_TICKET,
    }),
};

export const selectors = {
    getNewCheckbookRequest: ({ checks }) => checks.newCheckbookRequest,
    getNewCheckbookShouldShowLastValues: ({ checks }) => checks.newCheckbookShouldShowLastValues,
    getNewCheckbookData: ({ checks }) => checks.newCheckbookData,
    getNewCheckbookRequiredCredentials: ({ checks }) => checks.newCheckbookRequiredCredentials,
    getCheckbookTicketStatus: ({ checks }) => checks.newCheckbookTicket?.status,
    getCheckbookTicketId: ({ checks }) => checks.newCheckbookTicket?.idTransaction,
};
